import { FOXES_GIG_PAGE_CONTACT_SELLER_OPTIONS } from '../experimentsEnum';
import { inExperiment } from '..';

export default (abTests) => inExperiment(FOXES_GIG_PAGE_CONTACT_SELLER_OPTIONS, abTests);
